import styled from 'styled-components'
import {Flexbox} from '@components/ui/flexbox/FlexBox.tsx'

export const StyledDateFilterWrapper = styled(Flexbox)`
    width: 240px;
    flex-shrink: 0;
`
